import credencialesTipo from "@/credenciales.json";

const fieldsSub = [
  {
    key: "name",
    label: "Permisos",
    _style: "width:90%,",
  },

  {
    key: "switch",
    label: "",
    _style: "width:10%",
    sorter: false,
    filter: false,
  },
];
const fieldsModal = [
  {
    key: "credencial",
    label: "Credenciales",
    _style: "width:40%",
  },
];
const credencialesDefecto = [
  `@action:action=catalogos,documentos,balances,media,reportes,sync`,
  `@action:action=reportes|method=consultar_excel,consultar_html`,
  `@catalogo:schema=configuracion|method=consultar`,
  `@catalogo:schema=log_apps|method=consultar,actualizar,remplazar`,
];
export default {
  data() {
    return {
      allReportCredentials: [],
      id: this.$route.params.id,
      fieldsModal,
      fieldsSub,
      nombrePerfil: "",
      warningModal: false,
      error: "",
      isLoadingPage: false,
      isLoading: false,
      itemsModal: [],
      reportsNameExcel: [],
      reportsNamePDF: [],
      credenciales: [...credencialesDefecto],
    };
  },
  watch: {},
  methods: {
    addItem(item, index) {
      debugger
      const isAllReports =
        item.categoria === "Reportes" && item.type === "all" && item.id === 1;
      // this.tiempo_extra = !this.tiempo_extra;
      this.itemsModal.find((i) => i.credencial == item.categoria).credenciales[
        index
      ].value = !this.itemsModal.find((i) => i.credencial == item.categoria)
        .credenciales[index].value;

      let exist = this.credenciales.findIndex(
        (cred) => cred == item.credencial
      );

      this.itemsModal.find((i) => i.credencial == item.categoria).credenciales[
        index
      ].value
        ? exist === -1
          ? this.credenciales.push(
              isAllReports ? this.allReportCredentials : item.credencial
            )
          : ""
        : this.credenciales.splice(exist, 1);
    },

    cleanReportsCredencials() {
      const credencials = [...credencialesDefecto];
      // this.credenciales.forEach((i) => {
      //   credencials.push(i);
      // });
      this.itemsModal.forEach((categoria) => {
        const cre = categoria.credenciales
          .filter((ff) => ff.value)
          .map((m) => m.credencial);

        credencials.push(...cre);
      });
      this.credenciales = credencials;
    },
    getCredencialJSON() {
      const copy = JSON.parse(JSON.stringify(credencialesTipo));
      return copy.map((m) => {
        m.credenciales = m.credenciales.filter((f) => {
          return f.ambito ? f.ambito === this.$store.state.clave_empresa : true;
        });
        return m;
      });
    },
    getCredenciales() {
      this.isLoadingPage = true;
      this.itemsModal = this.getCredencialJSON();

      return Promise.all([
        this.$store.dispatch("getReportsHTTP", { reportes: true }),
        this.$store.dispatch("getReportsPdf", { reportes: true }),
        this.id
          ? this.$store.dispatch("customRolHTTP", {
              filter: {
                where: [
                  {
                    field: "id",
                    value: this.id,
                    operator: "=",
                  },
                ],
              },
            })
          : Promise.resolve(false),
      ])
        .then(([res, pdfs, items]) => {
          // debugger;
          const indx = this.itemsModal
            .map((m) => m.credencial)
            .indexOf("Reportes");
          const reporteGroup = this.itemsModal[indx];
          reporteGroup.credenciales.forEach((itm, i) => {
            itm.id = i + 1;
          });
          let lastCre = reporteGroup.credenciales.length;
          const excel = res.data
            ? res.data.map((report) => {
                return {
                  id: ++lastCre,
                  name: `${report.titulo} (Excel)`,
                  credencial: [
                    `@reporte:tipo=excel|nombre=${report.nombre}`,
                    `@reporte:tipo=jsoniq|nombre=${report.nombre}`,
                  ],
                  value: false,
                  type: "excel",
                  categoria: "Reportes",
                };
              })
            : [];
          const pdf = pdfs.data
            ? pdfs.data.map((report) => {
                return {
                  id: ++lastCre,
                  name: `${report.titulo} (Pdf)`,
                  credencial: [
                    `@reporte:tipo=html|nombre=${report.nombre}`,
                    `@reporte:tipo=jsoniq|nombre=${report.nombre}`,
                  ],
                  value: false,
                  type: "pdf",
                  categoria: "Reportes",
                };
              })
            : [];
          this.reportsNameExcel = excel;
          this.reportsNamePDF = pdf;
          console.log(this.reportsName);
          reporteGroup.credenciales.push(
            ...this.reportsNameExcel,
            ...this.reportsNamePDF
          );
          reporteGroup.credenciales = this.sortCredentials(
            reporteGroup.credenciales
          );
          console.log(reporteGroup)
          debugger;
          this.allReportCredentials = reporteGroup.credenciales.reduce(
            (v, c) => {
              if (Array.isArray(c.credencial)) {
                v.push(...c.credencial);
              } else {
                v.push(c.credencial);
              }
              return v;
            },
            []
          );

          if (items) {
            this.rol = items.data;

            this.nombrePerfil = items.data[0].rol;

            const crede = items.data[0].credenciales;

            let allReports = this.allReportCredentials.every((e) =>
              crede.includes(e)
            );

            this.itemsModal.forEach((categoria) => {
              categoria.credenciales.forEach((cre) => {
                if (Array.isArray(cre.credencial)) {
                  if (
                    this.getSwitchValueInCredencial(
                      cre.credencial,
                      crede,
                      categoria.credencial
                    )
                  ) {
                    cre.value = true;
                    this.credenciales.push(cre.credencial);
                  }
                } else {
                  crede.includes(cre.credencial)
                    ? ((cre.value = true),
                      this.credenciales.push(cre.credencial))
                    : "";
                }
              });
            });

            if (allReports) {
              const actualReports = this.itemsModal.filter(
                (item) => item.credencial !== "Reportes"
              );
              const templateAllReports = {
                id: 1,
                name: "Todos los reportes",
                credencial: [...this.allReportCredentials],
                value: true,
                categoria: "Reportes",
              };
              this.itemsModal = [
                ...actualReports,
                {
                  credencial: "Reportes",
                  credenciales: [templateAllReports],
                },
              ];
              this.cleanReportsCredencials();
            }
          }
        })
        .finally(() => (this.isLoadingPage = false));
    },
    sortCredentials(credenciales) {
      return credenciales.sort((a, b) => {
        const byType = a.type.localeCompare(b.type);
        if (byType === 0) {
          return a.name.localeCompare(b.name);
        }
        return byType;
      }).reduce((v, c) => {
        const find = v.find(f => f.name === c.name);
        if(find) {
          console.log(c.name)
          debugger
          find.credencial.push(...c.credencial)
          //v.push({...find, credencial: [...find.credencial, ...c.credencial]})
          //v.push(c)
        } else{
          v.push(c)
        }
        return v
      },[]);
    },

    getSwitchValueInCredencial(credenciales, todasCredenciales, categoria) {
      console.log(categoria);
      // if (categoria === "Reportes") {
      //   debugger;
      // }
      const indexs = todasCredenciales
        .map((credencial, ind) => {
          return credenciales[0] === credencial ? ind : null;
        })
        .filter((ff) => ff);
      if (indexs.length === 0) {
        return false;
      }
      for (let index of indexs) {
        let find = true;
        for (let i = 1; i < credenciales.length; i++) {
          if (todasCredenciales[i + index] !== credenciales[i]) {
            find = false;
            break;
          }
        }
        if (find) {
          return true;
        }
      }
      return false;
    },
    checkAllReports(item, index) {
      const actualReports = this.itemsModal.filter(
        (item) => item.credencial !== "Reportes"
      );
      this.addItem(item, index);
      const copy = this.getCredencialJSON();
      const indx = copy.map((m) => m.credencial).indexOf("Reportes");
      const credenciales = copy[indx].credenciales;
      credenciales.forEach((itm, i) => {
        itm.id = i + 1;
        itm.value = item.value;
      });

      if (item.value) {
        this.itemsModal = [
          ...actualReports,
          {
            credencial: "Reportes",
            credenciales: [
              { ...credenciales[0], credencial: this.allReportCredentials },
            ],
          },
        ];
      } else {
        const cleanReportsExcel = this.reportsNameExcel.map((i) => {
          return { ...i, value: false };
        });
        const cleanReportsPDF = this.reportsNamePDF.map((i) => {
          return { ...i, value: false };
        });
        this.itemsModal = [
          ...actualReports,
          {
            credencial: "Reportes",
            credenciales: this.sortCredentials([
              ...credenciales,
              ...cleanReportsExcel,
              ...cleanReportsPDF,
            ]),
          },
        ];
      }
      this.cleanReportsCredencials();
      // console.log(item.value);
    },
  },
  computed: {},
  created() {},
};
